$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('collection-part')) {
    customElements.define(
      'collection-part',
      class CollectionPart extends HTMLElement {
        productDetailModalBigPictrueSwiper = null;
        productDetailModalSmallPictrueSwiper = null;
        shopMoneyFormat = null;
        productInventoryQuantity = null;
        productDetailModalCopy = null;
        swiper = null;
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
          this.initMobileFilterItemEvent();
          this.initDrawer();
          this.initPagination();
          this.initFilter();
          this.initFilterWrapper();
        }

        onSubmitHandler(id = 'CollectionFiltersForm') {
          const formData = new FormData(this.querySelector(`#${id}`));
          const searchParams = new URLSearchParams(formData).toString();

          // 获取当前 URL 的所有参数
          const currentUrlParams = new URLSearchParams(window.location.search);
          const qParam = currentUrlParams.get('q');
          const typeParam = currentUrlParams.get('type');
          const sortByParam = currentUrlParams.get('sort_by');

          // 构建新的 URL
          let url = `${window.location.pathname}?${searchParams}`;

          // 添加需要保留的参数
          if (qParam) {
            url += `&q=${qParam}`;
          }
          if (typeParam) {
            url += `&type=${typeParam}`;
          }
          if (sortByParam) {
            url += `&sort_by=${sortByParam}`;
          }

          // 去除page参数
          url = url.replace(/page=\d+/, '');

          // 更细地址参数
          window.history.pushState({}, '', url);
          this.renderSectionFromFetch(url);
        }

        renderSectionFromFetch(url) {
          const _this = this;
          window.litime.showLoading();

          fetch(url)
            .then((response) => {
              if (response.status === 200) {
                return response.text();
              } else {
                throw new Error('Network response was not ok');
              }
            })
            .then((responseText) => {
              const html = responseText;
              if (html) {
                _this.renderProductGrid(html);
              }
              window.litime.hideLoading();
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              });
            })
            .catch((error) => {
              console.error('Error fetching data:', error);
              window.litime.hideLoading();
            });
        }

        renderProductGrid(html) {
          const innerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('CollectionProductGrid')?.innerHTML;
          this.querySelector('#CollectionProductGrid').innerHTML = innerHTML;
          const filterCount = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('filter_count')?.innerHTML;
          this.querySelector('#filter_count').innerHTML = filterCount;

          const filterCountMobile = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('filter_count_mobile')?.innerHTML;
          this.querySelector('#filter_count_mobile').innerHTML = filterCountMobile;

          const CollectionFiltersForm = this.querySelector('#CollectionFiltersForm');
          const mobileFilterForm = this.querySelector('#mobileFilterForm');

          const CollectionFiltersFormInnerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('CollectionFiltersForm')?.innerHTML;
          CollectionFiltersForm.innerHTML = CollectionFiltersFormInnerHTML;

          const mobileFilterFormInnerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('mobileFilterForm')?.innerHTML;
          mobileFilterForm.innerHTML = mobileFilterFormInnerHTML;

          this.removeInputEvent();

          this.init();
          this.initFilter();
          this.initPagination();
          this.closeFilterWrapper();
          this.initMobileFilterItemEvent();
          this.initDrawer();
          this.initFilterWrapper();
          if (typeof fetchInitCompare === 'function') {
            fetchInitCompare();
          }
        }

        initFilter() {
          const _this = this;
          const $showFilter = $(_this).find('.showFilter');
          $showFilter.on('click', function (event) {
            event.stopPropagation();
            $(_this).find('.filter_wrapper').removeClass('hidden');
            // 禁用body滚动
            window.litime.disableScroll();
          });
          const mobileFilterClose = $(_this).find('.mobile_filter_close');
          mobileFilterClose.on('click', function () {
            _this.closeFilterWrapper();
            // 启用body滚动
            window.litime.enableScroll();
          });
        }

        closeFilterWrapper() {
          const _this = this;
          $(_this).find('.filter_wrapper').addClass('hidden');
        }

        initMobileFilterItemEvent() {
          const _this = this;
          const mobileFilterItem = this.querySelectorAll('#CollectionFiltersForm .mobile_filter_item');
          const debouncedOnClick = window.litime.debounce(function (element) {
            _this.onSubmitHandler();
          }, 500);
          mobileFilterItem.forEach(function (item) {
            item.addEventListener('click', function (event) {
              event.stopPropagation();
              if (event.target.tagName === 'INPUT') {
                return;
              }
              if ($(this).find('input').prop('disabled')) {
                return;
              }
              if ($(this).find('input').prop('checked')) {
                $(this).find('input').prop('checked', false);
              } else {
                $(this).find('input').prop('checked', true);
              }
              debouncedOnClick();
            });
          });
          const $filterReset = $(_this).find('.filter-pc_reset');
          $filterReset.on('click', function () {
            const mobileFilterForm = $(_this).find('#CollectionFiltersForm');
            const input = mobileFilterForm.find('input');
            const progress = $(_this).find('.price-range-wrapper .progress');
            _this.removeInputEvent();
            input.each(function () {
              if ($(this).prop('checked') && $(this).prop('type') === 'checkbox') {
                $(this).prop('checked', false);
              }
              if ($(this).is('.min-range-input')) {
                $(this).val(0);
              }
              if ($(this).is('.max-range-input')) {
                const max = parseFloat($(this).attr('max'));
                $(this).val(max);
              }
              if ($(this).is('.range-min')) {
                $(this).val(0);
              }
              if ($(this).is('.range-max')) {
                const max = parseFloat($(this).attr('max'));
                $(this).val(max);
              }
            });
            progress.css('right', '0');
            _this.onSubmitHandler('CollectionFiltersForm');
          });
        }

        initPagination() {
          const _this = this;
          const $pagination = $(_this).find('.pagination');
          const $page = $pagination.find('.page');
          $page.on('click', function (event) {
            event.preventDefault();
            let urlParams = new URLSearchParams(window.location.search);
            urlParams.set('page', $(this).text());
            const url = window.location.pathname + '?' + urlParams.toString();
            window.history.pushState({}, '', url);
            _this.renderSectionFromFetch(url);
          });

          const $prev = $pagination.find('.prev');
          $prev.on('click', function (event) {
            event.preventDefault();
            let urlParams = new URLSearchParams(window.location.search);
            const page = urlParams.get('page');
            if (page > 1) {
              urlParams.set('page', page - 1);
              const url = window.location.pathname + '?' + urlParams.toString();
              window.history.pushState({}, '', url);
              _this.renderSectionFromFetch(url);
            }
          });

          const $next = $pagination.find('.next');
          $next.on('click', function (event) {
            event.preventDefault();
            let urlParams = new URLSearchParams(window.location.search);
            const page = urlParams.get('page') || 1;
            urlParams.set('page', +page + 1);
            const url = window.location.pathname + '?' + urlParams.toString();
            window.history.pushState({}, '', url);
            _this.renderSectionFromFetch(url);
          });
        }

        initShowMore() {
          const _this = this;
          const $showMore = $(_this).find('[data-show-more]');
          let height;
          let newHeight;
          let lastFilterLabel = '';
          $showMore.on('click', function () {
            const filterLabel = $(this).data('show-more');
            let $filterItemWrapper = $(_this).find(`[data-filter-wrapper="${filterLabel}"]`);
            $(_this).find(`[data-filter-more="${filterLabel}"]`).addClass('hidden');
            // 记录当前filter_item_wrapper的高度
            $filterItemWrapper.height('auto');
            const filterItemWrapperHeight = $filterItemWrapper.height();
            height = filterItemWrapperHeight;
            $(_this).find(`[data-filter-more="${filterLabel}"]`).removeClass('hidden');
            $(_this).find(`[data-show-less="${filterLabel}"]`).removeClass('hidden').addClass('flex');
            $(_this).find(`[data-show-more="${filterLabel}"]`).addClass('hidden');
            if (newHeight && lastFilterLabel === filterLabel) {
              $filterItemWrapper.height(height);
              setTimeout(() => {
                $filterItemWrapper.height(newHeight);
              }, 50);
            } else {
              lastFilterLabel = filterLabel;
              // 记录最新filter_item_wrapper的高度
              $filterItemWrapper = $(_this).find(`[data-filter-wrapper="${filterLabel}"]`);
              const newFilterItemWrapperHeight = $filterItemWrapper.height();
              $filterItemWrapper.height(filterItemWrapperHeight);
              newHeight = newFilterItemWrapperHeight;
              setTimeout(() => {
                $filterItemWrapper.height(newFilterItemWrapperHeight);
              }, 50);
            }
          });
          const $showLess = $(_this).find('[data-show-less]');
          $showLess.on('click', function () {
            const filterLabel = $(this).data('show-less');
            let $filterItemWrapper = $(_this).find(`[data-filter-wrapper="${filterLabel}"]`);
            const filterItemWrapperHeight = $filterItemWrapper.height();
            $(_this).find(`[data-show-less="${filterLabel}"]`).addClass('hidden');
            $(_this).find(`[data-show-more="${filterLabel}"]`).removeClass('hidden').addClass('flex');
            // 记录最新filter_item_wrapper的高度
            // $filterItemWrapper.height(newHeight);
            setTimeout(() => {
              $filterItemWrapper.height(height - 5);
            }, 50);
          });
        }

        initDrawer() {
          const _this = this;
          const $drawer = $(_this).find('.filter_item_drawer');
          $drawer.on('click', function () {
            const filterLabel = $(this).data('filter-drawer');
            let $filterItemWrapper = $(_this).find(`[data-filter-wrapper="${filterLabel}"]`);
            let $filterOpen = $(this).data('filter-open');
            if ($filterOpen) {
              // 实现收起
              // 修改data-filter-open为false
              $(this).data('filter-open', false);
              // 获取data-show-more
              $(_this).find(`[data-show-more="${filterLabel}"]`).css('opacity', 0);
              // 获取data-show-less
              $(_this).find(`[data-show-less="${filterLabel}"]`).css('opacity', 0);

              $(this).find('.filter_item_add').removeClass('hidden');
              $(this).find('.filter_item_remove').addClass('hidden');
              const filterItemWrapperHeight = $filterItemWrapper.height();
              $filterItemWrapper.height(filterItemWrapperHeight);
              setTimeout(() => {
                $filterItemWrapper.height(0);
                const showMoreWrapper = $(_this).find(`[data-more-wrapper="${filterLabel}"]`);
                showMoreWrapper.addClass('hidden');
              }, 50);
            } else {
              // 实现展开
              // 修改data-filter-open为true
              $(this).data('filter-open', true);
              // 获取data-show-more
              $(_this).find(`[data-show-more="${filterLabel}"]`).css('opacity', 1).removeClass('hidden');
              // 获取data-show-less
              $(_this).find(`[data-show-less="${filterLabel}"]`).css('opacity', 1).addClass('hidden');
              $(this).find('.filter_item_add').addClass('hidden');
              $(this).find('.filter_item_remove').removeClass('hidden');
              $(_this).find(`[data-filter-more="${filterLabel}"]`).addClass('hidden');
              $(_this).find(`[data-filter-more="${filterLabel}"]`).parent().removeClass('hidden');
              $filterItemWrapper.height('auto');
              const newFilterItemWrapperHeight = $filterItemWrapper.height();
              $filterItemWrapper.height(0);
              setTimeout(() => {
                $filterItemWrapper.height(newFilterItemWrapperHeight);
                const showMoreWrapper = $(_this).find(`[data-more-wrapper="${filterLabel}"]`);
                showMoreWrapper.removeClass('hidden');
              }, 50);
            }
          });
        }

        initFilterWrapper() {
          const _this = this;
          const $filterWrapper = $(_this).find('.filter_wrapper');
          const $drawer = $($filterWrapper).find('.filter_item_drawer');
          $drawer.on('click', function () {
            const filterLabel = $(this).data('filter-drawer');
            let $filterItemWrapper = $($filterWrapper).find(`[data-filter-wrapper="${filterLabel}"]`);
            let $filterOpen = $(this).attr('data-filter-open');
            if ($filterOpen === 'true') {
              // 实现收起
              // 修改data-filter-open为false
              $(this).attr('data-filter-open', false);
              // 获取data-show-more
              $($filterWrapper).find(`[data-show-more="${filterLabel}"]`).css('opacity', 0);
              // 获取data-show-less
              $($filterWrapper).find(`[data-show-less="${filterLabel}"]`).css('opacity', 0);

              $(this).find('.filter_item_add').removeClass('hidden');
              $(this).find('.filter_item_remove').addClass('hidden');
              $filterItemWrapper.height('auto');
              const filterItemWrapperHeight = $filterItemWrapper.height();
              $filterItemWrapper.height(filterItemWrapperHeight);
              setTimeout(() => {
                $filterItemWrapper.height(0);
                const showMoreWrapper = $($filterWrapper).find(`[data-more-wrapper="${filterLabel}"]`);
                showMoreWrapper.addClass('hidden');
              }, 50);
            } else {
              // 实现展开
              // 修改data-filter-open为true
              $(this).attr('data-filter-open', true);
              // 获取data-show-more
              $($filterWrapper).find(`[data-show-more="${filterLabel}"]`).css('opacity', 1).removeClass('hidden');
              // 获取data-show-less
              $($filterWrapper).find(`[data-show-less="${filterLabel}"]`).css('opacity', 1).addClass('hidden');
              $(this).find('.filter_item_add').addClass('hidden');
              $(this).find('.filter_item_remove').removeClass('hidden');
              $($filterWrapper).find(`[data-filter-more="${filterLabel}"]`).addClass('hidden');
              $($filterWrapper).find(`[data-filter-more="${filterLabel}"]`).parent().removeClass('hidden');
              $filterItemWrapper.height('auto');
              const newFilterItemWrapperHeight = $filterItemWrapper.height();
              $filterItemWrapper.height(0);
              setTimeout(() => {
                $filterItemWrapper.height(newFilterItemWrapperHeight);
                const showMoreWrapper = $($filterWrapper).find(`[data-more-wrapper="${filterLabel}"]`);
                showMoreWrapper.removeClass('hidden');
              }, 50);
            }
          });
          const $showMore = $($filterWrapper).find('[data-show-more]');
          let height;
          let newHeight;
          let lastFilterLabel = '';
          $showMore.on('click', function () {
            const filterLabel = $(this).data('show-more');
            let $filterItemWrapper = $($filterWrapper).find(`[data-filter-wrapper="${filterLabel}"]`);
            $($filterWrapper).find(`[data-filter-more="${filterLabel}"]`).addClass('hidden');
            // 记录当前filter_item_wrapper的高度
            $filterItemWrapper.height('auto');
            const filterItemWrapperHeight = $filterItemWrapper.height();
            height = filterItemWrapperHeight;
            $($filterWrapper).find(`[data-filter-more="${filterLabel}"]`).removeClass('hidden');
            $($filterWrapper).find(`[data-show-less="${filterLabel}"]`).removeClass('hidden').addClass('flex');
            $($filterWrapper).find(`[data-show-more="${filterLabel}"]`).addClass('hidden');
            if (newHeight && lastFilterLabel === filterLabel) {
              $filterItemWrapper.height(height);
              setTimeout(() => {
                $filterItemWrapper.height(newHeight);
              }, 50);
            } else {
              lastFilterLabel = filterLabel;
              // 记录最新filter_item_wrapper的高度
              $filterItemWrapper = $($filterWrapper).find(`[data-filter-wrapper="${filterLabel}"]`);
              const newFilterItemWrapperHeight = $filterItemWrapper.height();
              $filterItemWrapper.height(filterItemWrapperHeight);
              newHeight = newFilterItemWrapperHeight;
              setTimeout(() => {
                $filterItemWrapper.height(newFilterItemWrapperHeight);
              }, 50);
            }
          });
          const $showLess = $($filterWrapper).find('[data-show-less]');
          $showLess.on('click', function () {
            const filterLabel = $(this).data('show-less');
            let $filterItemWrapper = $($filterWrapper).find(`[data-filter-wrapper="${filterLabel}"]`);
            $($filterWrapper).find(`[data-show-less="${filterLabel}"]`).addClass('hidden');
            $($filterWrapper).find(`[data-show-more="${filterLabel}"]`).removeClass('hidden').addClass('flex');
            // 记录最新filter_item_wrapper的高度
            // $filterItemWrapper.height(newHeight);
            setTimeout(() => {
              $filterItemWrapper.height(height);
            }, 50);
          });
          const mobileFilterItem = this.querySelectorAll('.filter_wrapper .mobile_filter_item');
          mobileFilterItem.forEach(function (item) {
            item.addEventListener('click', function (event) {
              event.stopPropagation();
              if (event.target.tagName === 'INPUT') {
                return;
              }
              if ($(this).find('input').prop('disabled')) {
                return;
              }
              if ($(this).find('input').prop('checked')) {
                $(this).find('input').prop('checked', false);
              } else {
                $(this).find('input').prop('checked', true);
              }
            });
          });
          const $filterReset = $($filterWrapper).find('.filter_reset');
          $filterReset.on('click', function () {
            const mobileFilterForm = $($filterWrapper).find('#mobileFilterForm');
            const input = mobileFilterForm.find('input');
            const progress = $($filterWrapper).find('.price-range-wrapper .progress');
            input.each(function () {
              if ($(this).is(':visible')) {
                $(this).prop('checked', false);
              }
              if ($(this).is('.min-range-input')) {
                $(this).val(0);
              }
              if ($(this).is('.max-range-input')) {
                const max = parseFloat($(this).attr('max'));
                $(this).val(max);
              }
              if ($(this).is('.range-min')) {
                $(this).val(0);
              }
              if ($(this).is('.range-max')) {
                const max = parseFloat($(this).attr('max'));
                $(this).val(max);
              }
            });
            progress.css('right', '0');
            _this.onSubmitHandler('mobileFilterForm');
            $($filterWrapper).addClass('hidden');
          });

          const applyButton = $($filterWrapper).find('.filter_apply');
          applyButton.on('click', function () {
            _this.onSubmitHandler('mobileFilterForm');
          });
        }

        debouncedOnSubmit = window.litime.debounce((event) => {
          event.preventDefault();
          this.onSubmitHandler();
        }, 500);

        init() {
          const _this = this;
          if (this.querySelector('#CollectionFiltersForm')) {
            this.querySelector('#CollectionFiltersForm').addEventListener('input', this.debouncedOnSubmit.bind(this));
          }

          // 获取data-sortby的元素
          let dataSortbys = $(this.querySelectorAll('[data-sortby]'));
          dataSortbys.on('click', function (event) {
            // 获取data-sortby的值
            let dataSortbyValue = $(this).data('sortby');
            // 获取地址栏所有参数
            let urlParams = new URLSearchParams(window.location.search);
            urlParams.set('sort_by', dataSortbyValue);
            const url = window.location.pathname + '?' + urlParams.toString();
            window.history.pushState({}, '', url);
            _this.renderSectionFromFetch(url);
          });
        }

        removeInputEvent() {
          if (this.querySelector('#CollectionFiltersForm')) {
            this.querySelector('#CollectionFiltersForm').removeEventListener(
              'input',
              this.debouncedOnSubmit.bind(this)
            );
          }
        }
      }
    );
  }
});
